module.exports = __webpack_public_path__ + "static/media/logbook-connector.ee5a7e86.svg";